import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { MatomoTrackerService } from '../../services';

export type MatomoModuleName = 'Portal' | 'Task Manager';

export function initializeMatomo(moduleName: MatomoModuleName, analyticsEnabled: boolean) {
  return () => {
    const matomo = inject(MatomoTrackerService);
    const isLocalhost = globalThis.location.href.includes('localhost');

    // A browser window session should always get a stable session id on startup,
    // even when analytics transport is disabled locally.
    matomo.ensureSessionId();

    if (isLocalhost && !analyticsEnabled) {
      return;
    }

    const router = inject(Router);

    matomo.setupAnalytics(moduleName);
    // Ensure a stable matomo_id exists for this session (created on demand)
    // This may perform an async SHA-256 computation, so await it before routing/tracking starts.
    return matomo.ensureMatomoId().then(() => matomo.initRouterTracking(router));
  };
}
